import {NavigationTabsModuleTabModel} from "./navigation-tabs-module.tab-model";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../containers/competitor-container/competitor-container.consts";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {override} from "mobx";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class BracketsTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @override get isVisible(): Boolean {
    return this.entity.hasBrackets;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.hashParams.brackets === NEW_COMPETITOR_CONTAINER.FILTERS.brackets;
  }

  get eventName(): String {
    return ACTION_TYPES.bracketsClick;
  }

  get eventParams(): Object {
    const eventParams = {
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[this.entity.objectType],
      entityId: this.entity.id,
      source: APP.ANALYTICS.SOURCES[this.entity.name],
      sportTypeId: this.entity.sport.id
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.brackets;
  }

  get elementId(): String {
    return 'navigation-tabs_brackets';
  }
}
